import { useQuery } from '@tanstack/react-query';

import { meQuery, type MeOut } from '@/lib/api/queries';

export interface MeState {
  /** 目前登入的使用者；未登入（或工作階段剛失效）時是 `null`。 */
  me: MeOut | null;
  /** 第一次問「我是誰」還沒回來。此時不要畫「登入」，也不要畫頭像——畫骨架。 */
  isLoading: boolean;
}

/**
 * 「我是誰」的唯一入口。TopNav 的 UserMenu、自選股頁、☆ 按鈕都從這裡讀，
 * 所以登入／登出／401 只要改 `qk.me()` 一個 key，整個畫面就一起換。
 */
export function useMe(): MeState {
  const query = useQuery(meQuery());
  return { me: query.data ?? null, isLoading: query.isPending };
}
